import React from 'react'
import { FieldProps } from 'formik'
import { Checkbox, FormControl, FormControlLabel } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

import { GenericFormProps, getError, hasError, isFormLoading, isViewOnly } from './helpers'
import { commonCheckboxStyles, errorStyle } from './styles'
import CustomFormHelperText from './CustomFormHelperText'
import LoadingFieldIndicator from './LoadingFieldIndicator'

type Props = {
  disabled?: boolean
  fullWidth?: boolean
  helperText?: string
  label: string
}

const useStyles = makeStyles((theme) => ({
  ...commonCheckboxStyles(theme),
  checkbox: errorStyle({
    color: theme.palette.error.main,
  }),
  control: {
    marginTop: 0,
  },
}))

const CustomCheckboxWithoutInitialValue: React.FunctionComponent<Props & GenericFormProps & FieldProps> = (props) => {
  const {
    disabled = false,
    fullWidth = false,
    field: { name, value },
    form: { setFieldValue },
    helperText,
    label,
  } = props

  const classes = useStyles(props)

  if (isFormLoading(props)) {
    return <LoadingFieldIndicator {...props} isCheckbox />
  }

  return (
    <FormControl
      disabled={isViewOnly(props) || disabled}
      fullWidth={fullWidth}
      classes={{
        root: classes.control,
      }}
    >
      <FormControlLabel
        classes={{
          label: classes.label,
        }}
        checked={Boolean(value)}
        control={<Checkbox className={classes.checkbox} color="primary" />}
        label={label}
        name={name}
        onChange={(_, checked) => setFieldValue(name, checked)}
        value={name}
      />
      {(hasError(props) || helperText) && (
        <CustomFormHelperText error={hasError(props)}>
          {hasError(props) ? getError(props) : helperText}
        </CustomFormHelperText>
      )}
    </FormControl>
  )
}

export default CustomCheckboxWithoutInitialValue
